import "./SinglePostTemplate.module.css"
import SiteHeader from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import SiteFooter from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <SiteHeader />
      <SinglePostTemplate />
      <SiteFooter />
    </div>
  )
}
